import { useGetDepartmentByReport } from '../services/api';
import { SimpleDepartmentsTable } from './DepartmentsTableSimple';

export const ReportDepartmentsTable: React.FC<{ reportId: string }> = ({ reportId }) => {
  const { data, error, isLoading } = useGetDepartmentByReport({ reportId });
  return <SimpleDepartmentsTable data={data} isLoading={isLoading} error={error} />;
};
